import React, { useState, useEffect } from 'react';
import Constants from 'components/layout_and_quote_builder/Constants.jsx'

// The material sheet(s) are computed server-side from the section's templates and the fixed
// allowances (issue #5194, "Malzeme Tabakasi Bulma"). They are no longer chosen -- or shown -- on the
// page: the material sheet dimension dropdowns are hidden. This component keeps the (invisible) job of
// forwarding the computed layout_dimension_ids (which arrive in `defaultValues` from the
// default-material-values endpoint) and the solution-filtering toggle to the combinations request via
// publicSetter; only the filtering and bobbin toggles are rendered.
// Corrugated flexo (and flexo_on_carton) is always produced on a bobbin, so its "bobbin" checkbox is
// forced on and cannot be unchecked; corrugated_cardboard_offset never shows it (issue #5311, A1).
const FLEXO_PART_TYPES = ['corrugated_cardboard_flexo', 'corrugated_cardboard_flexo_on_carton'];

const ChooseLayoutDimensions = ({ index, defaultValues, publicSetter, onBobbinChange }) => {
  const [layout_dimension_filtering_enabled, set_layout_dimension_filtering_enabled] = useState(false);

  // The bobbin question. Its default and editability follow the section's part_type (A1):
  // carton starts unchecked, carton_lamination starts checked, corrugated flexo is forced on, and
  // corrugated_cardboard_offset hides it entirely.
  const part_type = defaultValues && defaultValues.part_type;
  const bobbin_shown = part_type != undefined && part_type !== 'corrugated_cardboard_offset';
  const bobbin_forced = FLEXO_PART_TYPES.includes(part_type);
  const bobbin_default = bobbin_forced || part_type === 'carton_lamination';
  const [bobbin_enabled, set_bobbin_enabled] = useState(bobbin_default);

  const effective_bobbin_enabled = bobbin_forced ? true : bobbin_enabled;

  const getPublicData = () => {
    return {
      ...defaultValues,
      layout_dimension_filtering_enabled,
      bobbin_enabled: effective_bobbin_enabled,
    }
  }

  // When the part_type becomes known (or changes), reset the checkbox to its part_type default.
  useEffect(() => {
    set_bobbin_enabled(bobbin_default);
  }, [part_type])

  useEffect(() => {
    if (publicSetter != undefined) {
      publicSetter(() => getPublicData());
    }
    emitEvent(Constants.layout_dimension_changed, { index: index });
  }, [layout_dimension_filtering_enabled, effective_bobbin_enabled])

  return (<>
    <div>
      <table className="table table-bordered">
        <tbody>
          {bobbin_shown &&
            <tr>
              <td colSpan="3" style={{paddingTop: '10px', paddingBottom: '10px'}}>
                <label style={{display: 'flex', alignItems: 'center', cursor: bobbin_forced ? 'default' : 'pointer'}}>
                  <input
                    type="checkbox"
                    checked={effective_bobbin_enabled}
                    disabled={bobbin_forced}
                    onChange={(e) => {
                      set_bobbin_enabled(e.target.checked);
                      // Re-run the material-sheet finder for the new bobbin value so "Chosen material
                      // dimensions" recomputes (bobbin true/false changes the result).
                      if (onBobbinChange != undefined) { onBobbinChange(e.target.checked); }
                    }}
                    style={{marginRight: '8px'}}
                  />
                  <span>{t('quote_builder.bobbin')}</span>
                </label>
              </td>
            </tr>
          }
          <tr>
            <td colSpan="3" style={{paddingTop: '10px', paddingBottom: '10px'}}>
              <label style={{display: 'flex', alignItems: 'center', cursor: 'pointer'}}>
                <input
                  type="checkbox"
                  checked={layout_dimension_filtering_enabled}
                  onChange={(e) => set_layout_dimension_filtering_enabled(e.target.checked)}
                  style={{marginRight: '8px'}}
                />
                <span>{t('quote_builder.solution_filtering')}</span>
              </label>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div style={{'clear': 'both'}}></div>
  </>)
}

export default ChooseLayoutDimensions;
